import React, { useState, useEffect } from 'react';
import { getQueryVariable, fetchApi } from '../Utils/Fetch';
import { useNavigate } from 'react-router-dom';
import Modal from '../Components/Modal';
import ConsentModal from '../Components/ConsentModal';
import '../App.css';
import MainForm from '../Components/MainForm';
import { useTranslation } from 'react-i18next';
import { useStoreCountry } from '../Contexts/StoreCountryContext';
import ConfirmationSuccess from '../Components/ConfirmationSuccess';
import { DOUBLE_OPT_IN_METHOD, PAGE_STATUS_LANDING } from '../Utils/Constants';
var Markdown = require('react-remarkable');

function Landing() {
    var uid = getQueryVariable("uid");
    const navigate = useNavigate();
    const { t, i18n, ready } = useTranslation();
    const { store, setStore } = useStoreCountry();
    const [pageStatus, setPageStatus] = useState(PAGE_STATUS_LANDING.PENDING);
    const [doubleOptInMethod, setDoubleOptInMethod] = useState("");
    const [modal, setModal] = useState({ show: false, size: 'md', title: 'title', body: 'body' });
    const [consentModal, setConsentModal] = useState({ show: false, autoSubmit: null, setAutoSubmit: null, formData: null, setFormData: null });

    useEffect(() => {
        async function checkUid() {
            if (!store) {
                try {
                    var res = await fetchApi('validate-uid', { method: 'POST', body: { uid: uid } });
                    if (res.doubleOptInAlreadyDone === true) {
                        setPageStatus(PAGE_STATUS_LANDING.ALREADY_DOUBLE_OPT_IN);
                    }
                    else if (res.doubleOptInAlreadyDone === false) {
                        setPageStatus(PAGE_STATUS_LANDING.COMPLETED);
                    }
                    else {
                        setStore(res.store);
                    }
                }
                catch (err) {
                    console.error(err);
                    setPageStatus(PAGE_STATUS_LANDING.INVALID_UID);
                }
            }
        }
        checkUid();
    }, [setStore, store, uid]);

    useEffect(() => {
        async function loadTerms() {
            if (store && ready) {
                if (i18n.resolvedLanguage !== 'en') {
                    try {
                        var terms = await fetchApi(`terms/${i18n.resolvedLanguage}`, { method: 'GET', query: { store: store } });
                        i18n.addResourceBundle(i18n.resolvedLanguage, "translation", terms);
                    }
                    catch (err) {
                        console.error(err);
                    }
                }
                try {
                    var defaultTerms = await fetchApi('terms/en', { method: 'GET', query: { store: store } });
                    i18n.addResourceBundle('en', "translation", defaultTerms);
                    setPageStatus(PAGE_STATUS_LANDING.VALID_UID);
                } catch (err) {
                    console.error(err);
                }
            }
        }
        loadTerms();
    }, [store, ready, i18n]);

    if (pageStatus === PAGE_STATUS_LANDING.VALID_UID && ready) {
        return (
            <>
                <ConsentModal modal={consentModal} setModal={setConsentModal}></ConsentModal>
                <Modal modal={modal} setModal={setModal}></Modal>
                <MainForm uid={uid} setModal={setModal} modal={modal} setConsentModal={setConsentModal} consentModal={consentModal} setPageStatus={setPageStatus} setDoubleOptInMethod={setDoubleOptInMethod}></MainForm>
            </>
        );
    }
    else if (pageStatus === PAGE_STATUS_LANDING.INVALID_UID && ready) {
        return (
            <div className='container'>
                <div className="alert alert-light my-5" role="alert">
                    <h4><Markdown>{t("token_expired")}</Markdown></h4>
                </div>
            </div>
        );
    }
    else if (pageStatus === PAGE_STATUS_LANDING.COMPLETED && ready) {
        return (
            <div className='container'>
                <div className="alert alert-light my-5" role="alert">
                    <h4><Markdown>{doubleOptInMethod === DOUBLE_OPT_IN_METHOD.PHONE ? t("success_form_submit_phone") : t("success_form_submit_email")}</Markdown></h4>
                </div>
            </div>
        );
    }
    else if (pageStatus === PAGE_STATUS_LANDING.PENDING) {
        return (
            <div className="loader-container my-5">
                <img className='rotate' src='/assets/brand/Loro-Piana_Logo-174U_2.png' width="200" height="180" alt="logo"></img>
            </div>
        );
    }
    else if (pageStatus === PAGE_STATUS_LANDING.ALREADY_DOUBLE_OPT_IN) {
        return (
            <ConfirmationSuccess uid={uid}></ConfirmationSuccess>
        );
    }
    else {
        return (<></>);
    }
}

export default Landing;